function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class CurrentUserState {
    get userState() {
        return this._userState;
    }
    set userState(value) {
        this._userState = value;
    }
    constructor(){
        _define_property(this, "_userState", undefined);
    }
}
export const currentUserState = new CurrentUserState();
